import { Preferences } from '@capacitor/preferences';
import { getPlatform } from './helpers';

export const TOKEN_KEY = 'wf-token';

const platform = getPlatform();

export const getStoredAuthToken = async () => {
  try {
    if (platform === 'web') return;
    const { value } = await Preferences.get({ key: TOKEN_KEY });
    return value || null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

export const storeAuthToken = async (token) => {
  try {
    if (platform === 'web') return;
    await Preferences.set({ key: TOKEN_KEY, value: token });
  } catch (error) {
    console.error('Error setting auth token:', error);
  }
};

export const removeStoredAuthToken = async () => {
  if (platform === 'web') return;
  await Preferences.remove({ key: TOKEN_KEY });
};
